import Article from 'models/Article';

import Component from './component';

export enum DraftReplaceKeys {
    Products = 'RelatedProducts',
}

export interface Props extends ParentProps {
    content: string;
    article: Article
}

export interface ParentProps {
}

Component.defaultProps = {
    content: '',
    article: null,
};
export default Component;
